import { render } from "./Brightness.vue?vue&type=template&id=351d314c&scoped=true&ts=true"
import script from "./Brightness.vue?vue&type=script&lang=ts"
export * from "./Brightness.vue?vue&type=script&lang=ts"

import "./Brightness.vue?vue&type=style&index=0&id=351d314c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-351d314c"]])

export default __exports__